export default "__VITE_ASSET__C_X5W4ex__"